






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponseRobo} from '@/model/resource/ResponseRobo'
import {InputResponseRoboSchema} from '@/schema/resource/ResponseRobo/InputResponseRoboSchema'

@Component
export default class PersistResponseRoboView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponseRoboSchema()
  responseRobo = new ResponseRobo()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responseRobo.getResponseRobo(id)
    }

    $.await.done('getResponseRobo')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.responseRobo.persistResponseRobo()
    await Helper.successAndPush('system.success.persist', '/response-robo/list')
  }
}
